import { render, staticRenderFns } from "./AddItemsInventory.vue?vue&type=template&id=51619b68&scoped=true&"
import script from "./AddItemsInventory.vue?vue&type=script&lang=js&"
export * from "./AddItemsInventory.vue?vue&type=script&lang=js&"
import style0 from "./AddItemsInventory.vue?vue&type=style&index=0&id=51619b68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51619b68",
  null
  
)

export default component.exports